import { Button } from "antd";
import LabeledInput from "components/Form/LabeledInput";
import LabeledTextArea from "components/Form/LabeledTextArea";
import LabeledUploadInput from "components/Form/LabeledUploadInput";
import useCreateNews from "hooks/broadcasts/useCreateNews";
import { PiSpeakerNoneLight } from "react-icons/pi";

export default function CreateNews() {
  const { control, handleSubmit, handleUpload, loading, onSubmit } =
    useCreateNews();

  return (
    <div className="w-full bg-white rounded-lg p-6 shadow-lg">
      <div className="pt-5 pb-5">
        <h1 className="p-5 font-light text-lg text-center">New News</h1>
        <div className="w-full">
          <div className="w-full relative h-1 top-7 overflow-clip rounded-md">
            <div className="w-1/2 bg-black h-full rounded-md"></div>
          </div>
          <div className="relative w-full flex justify-center">
            <div className="relative h-14 w-14 bg-black rounded-full flex items-center justify-center text-white text-2xl">
              <PiSpeakerNoneLight />
            </div>
          </div>
        </div>
        <p className="text-center mt-2 text-sm font-n">New News</p>
      </div>
      <div className="py-8 px-5">
        <form onSubmit={handleSubmit(onSubmit)} className="mx-auto max-w-xl">
          <div className="w-full mb-5">
            <LabeledInput
              label="Title"
              type="text"
              control={control}
              name="title"
              placeholder=""
            />
          </div>
          <div className="w-full mb-5">
            <LabeledUploadInput
              control={control}
              name="image"
              placeholder="Select Image"
              label="Image"
              action={handleUpload}
            />
          </div>
          <div className="w-full mb-5">
            <LabeledTextArea
              placeholder="Enter your message"
              control={control}
              label="Message Content"
              name="content"
              rows={6}
            />
          </div>
          <div className="w-full flex mt-3 justify-end">
            <Button
              loading={loading}
              htmlType="submit"
              type="primary"
              className="py-2 px-16 rounded-md h-auto font-semibold"
            >
              Post
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
